'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ImagePanoramaFishEye = function ImagePanoramaFishEye(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
  );
};
ImagePanoramaFishEye = (0, _pure2.default)(ImagePanoramaFishEye);
ImagePanoramaFishEye.displayName = 'ImagePanoramaFishEye';
ImagePanoramaFishEye.muiName = 'SvgIcon';

exports.default = ImagePanoramaFishEye;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/image/panorama-fish-eye.js
// module id = 2448
// module chunks = 0